import { getPartnerUserImpersonationSuggestions } from 'app/services/partnerImpersonationService';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const handleApiDataResponse = (data = {}) => {
   const { users = [] } = data;
   return users.map((user = {}) => {
      const {
         firstName = '',
         lastName = '',
         orgName = '',
         username = '',
      } = user;

      return ({
         ...user,
         label: `${ orgName } | ${ username } | ${ firstName } ${ lastName }`,
      });
   });
};

export default withAutosuggestWrapper(
   withInputErrorMessage(
      autosuggestFactory({
         apiPromise: getPartnerUserImpersonationSuggestions,
         handleApiDataResponse,
      }),
   ),
   {
      handleCustomError: (errorPtr = {}) => (errorPtr?.userId === 'Required!'),
   },
);
